import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ProviderGame } from 'src/app/apis/preload-system.service';
import { AppCore } from 'src/app/utils/classes/app-core';

@Component({
  selector: 'app-game-provider-img',
  templateUrl: './game-provider-img.component.html',
  styleUrls: ['./game-provider-img.component.scss']
})
export class GameProviderImgComponent extends AppCore implements OnChanges {
  @Input() provider: string;

  ProviderData: ProviderGame;
  constructor() {
    super();
  }

  ngOnChanges() {
    this.ProviderData = this.constDataPreload.provider.find(c => c.game_provider == this.provider);
  }

}
